import React from "react";
import { getPathName } from "../../../utils/utilsFunc";
import { CGE } from "..";
import * as XLSX from "xlsx";

function ButtonExcel({ props }) {
  function encodeCell(row, column) {
    return XLSX.utils.encode_cell({ r: row, c: column });
  }

  function deleteRow(ws, rowIndex) {
    const variable = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = rowIndex; R < variable.e.r; ++R) {
      for (let C = variable.s.c; C <= variable.e.c; ++C) {
        ws[encodeCell(R, C)] = ws[encodeCell(R + 1, C)];
      }
    }

    variable.e.r--;
    ws["!ref"] = XLSX.utils.encode_range(variable.s, variable.e);
  }

  function exportHandler(name, data, headers) {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([{}], {
      header: headers,
    });
    XLSX.utils.sheet_add_json(ws, data, { origin: "A2" });
    XLSX.utils.book_append_sheet(wb, ws, name.substring(0,31));
    deleteRow(ws, 1);
    XLSX.writeFile(wb, `${name}.xlsx`, { bookType: "xlsx" });
  }

  function exportAllDataRequest() {
    if(!props.excelData) {
      props?.setLoading(true);
        props?.dispatch({
          payload: { idClient: props?.state.idList, numPage: 1, quantItems: props?.state.idList.length },
          type: props?.ACTIONS.SET_ALLDATAREQUEST,
        });
    }else {
      exportHandler(
        props?.fileName?props?.fileName:getPathName(),
        props.excelData,
        getPathName() ==="reports"?props.arTitles:props.arTitles[getPathName()].map((el) => el.label)
      )
    }
  }

  React.useEffect(() =>{

    const objCb = props?.state?.allDataRequestResponse;
    if (objCb) {
      props?.setLoading(false);
      
      if (objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.RETURN === 0) {
        exportHandler(
          props?.fileName?props?.fileName:getPathName(),
          objCb.ConsultarListaEstadoServiciosResponse?.ITEM,
          getPathName() ==="reports"?props.arTitles:props.arTitles[getPathName()].map((el) => el.label)
        )
        props.setExcelData(objCb.ConsultarListaEstadoServiciosResponse?.ITEM);
      } else {
        props?.setGlobalAlert(props.textFetchError, "warning", true, "Advertencia");
      }
      props?.dispatch({
        payload: null,
        type: props?.ACTIONS.SET_ALLDATAREQUEST_RESPONSE,
      });
    }
  },props?.state?.allDataRequestResponse);
  
  return (
    <div>
      {props && props.auxArray && props.arTitles && (
        <CGE.Button
          id="btn-csv"
          label="Exportar Excel"
          disabled={props.disabled}
          onClick={() => {
            !props?.excelFunc?
              exportHandler(
                props?.fileName?props?.fileName:getPathName(),
                props.auxArray,
                getPathName() ==="reports"?props.arTitles:props.arTitles[getPathName()].map((el) => el.label)
              )
            :
            exportAllDataRequest()
          }}
        />
    )}
    </div>

  );
}

export default ButtonExcel;
